import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { UPDATE_CONFIRM_CHECKLIST_POPUP, UPDATE_CONFIRM_CHECKLIST_POPUP_MSB } from '@/graphql/mutations/lessonPopup';
import { bizmatesApi } from '@/utils/bizmatesApi';
import qs from 'qs';

import logger from '@/modules/Logger';

export const UpdateConfirmCheckListPopupService = {
  msb: async (params, callback, callbackErr = null) => {
    logger.debug(`[MyStage ConfirmChecklistPopup] Update popup data using MSB GraphQL endpoint`, {
      operation: 'confirm-checklist-popup:update'
    });

    await myStageApolloProvider.defaultClient
      .mutate({
        fetchPolicy: 'no-cache',
        mutation: UPDATE_CONFIRM_CHECKLIST_POPUP_MSB,
        variables: params
      })
      .then(response => {
        callback(response.data?.mystageConfirmChecklistPopup);
      })
      .catch((error) => {
        logger.error('[MyStage ConfirmChecklistPopup] Error on updating popup data', {
          operation: 'confirm-checklist-popup:update',
          error: error.message
        });
        if (callbackErr != undefined && callbackErr != null) {
          callbackErr(error.message);
        }
      });
  },
  mbti: async (params, callback, callbackErr = null) => {
    logger.debug(`[MyStage ConfirmChecklistPopup] Update popup data using MBTI GraphQL endpoint`, {
      operation: 'confirm-checklist-popup:update'
    });

    await apolloProvider.defaultClient
      .mutate({
        fetchPolicy: 'no-cache',
        mutation: UPDATE_CONFIRM_CHECKLIST_POPUP,
        variables: params
      })
      .then(response => {
        callback(response.data?.mystage_confirm_checklist_popup);
      })
      .catch((error) => {
        logger.error('[MyStage ConfirmChecklistPopup] Error on updating popup data', {
          operation: 'confirm-checklist-popup:update',
          error: error.message
        });
        if (callbackErr != undefined && callbackErr != null) {
          callbackErr(error.message);
        }
      });
  },

  legacy: async (params, callback, callbackErr = null) => {
    logger.debug(`[MyStage ConfirmChecklistPopup] Update popup data using legacy endpoint`, {
      operation: 'confirm-checklist-popup:update'
    });

    await bizmatesApi.post('lesson/confirmChecklistPopup', qs.stringify(params), {},
      response => {
        callback(response.data);
      },
      err => {
        logger.error('[MyStage ConfirmChecklistPopup] Error on updating popup data', {
          operation: 'confirm-checklist-popup:update',
          error: err
        });
        if (callbackErr != undefined && callbackErr != null) {
          callbackErr(err);
        }
      }
    );
  }
};
